import React from 'react';
export default ({ className, ...htmlAttributes }: { className?: string }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		className={className}
		{...htmlAttributes}
	>
		<path
			d="M12.1797 2.69531L17.1797 7.69531C17.4141 7.92969 17.4141 8.35938 17.1797 8.59375C16.9453 8.82812 16.5156 8.82812 16.2812 8.59375L12.375 4.64844V15.625C12.375 15.9766 12.0625 16.25 11.75 16.25C11.3984 16.25 11.125 15.9766 11.125 15.625V4.64844L7.17969 8.59375C6.94531 8.82812 6.51562 8.82812 6.28125 8.59375C6.04688 8.35938 6.04688 7.92969 6.28125 7.69531L11.2812 2.69531C11.5156 2.46094 11.9453 2.46094 12.1797 2.69531ZM4.25 15.625V19.375C4.25 20.4297 5.07031 21.25 6.125 21.25H17.375C18.3906 21.25 19.25 20.4297 19.25 19.375V15.625C19.25 15.3125 19.5234 15 19.875 15C20.1875 15 20.5 15.3125 20.5 15.625V19.375C20.5 21.1328 19.0938 22.5 17.375 22.5H6.125C4.36719 22.5 3 21.1328 3 19.375V15.625C3 15.3125 3.27344 15 3.625 15C3.9375 15 4.25 15.3125 4.25 15.625Z"
			fill="currentColor"
		/>
	</svg>
);
